/** PARAVOGUE Parapharmacie Catalog Data & Routing **/
window.PARAVOGUE_CATALOG = {
  "categories": {
    "visage": [
      {
        "title": "Cerave gel moussant nettoyant peau normale à grasse 473ml - Gel moussant 20ML + gel creme hydratant 15ml + Trousse OFFERTS",
        "vendor": "Cerave",
        "price": 147,
        "compareAt": 150,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/GELMOUSSANT_bebbf92a-dffd-4d9c-b7b9-064f8ed9662e.png?v=1769107657",
        "handle": "cerave-gel-moussant-nettoyant-peau-normale-a-grasse-473ml-gel-moussant-20ml-trousse-offerts",
        "category": "visage",
        "tags": "cerave gel, Gel Moussant, Gel moussant purifiant, gel nettoyents, peau normale, PEAU NORMALE A GRASSE, cerave, visage"
      },
      {
        "title": "Cerave baume hydratant – 340 g - Crème Lavante 20ml + Crème Hydratante 15ml + Trousse OFFERTS",
        "vendor": "Cerave",
        "price": 134,
        "compareAt": 162,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/GHFTG.png?v=1769108266",
        "handle": "cerave-baume-hydratant-340-g-creme-lavante-20ml-creme-hydratante-15ml-trousse-offerts",
        "category": "visage",
        "tags": "baume, Baume Hydratant, crème hydratante, céramides, hydratant, hydratante, hydratation, hydrate, lait, lotion, moisturising cream, peau sèche, peaux sèches, Soin, très sèches, cerave, corps"
      },
      {
        "title": "La Roche-Posay Effaclar Duo+M 40ml – Anti-Imperfections Peaux Grasses",
        "vendor": "La Roche-Posay",
        "price": 179,
        "compareAt": 185,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/la-roche-posay-effaclar-duo-m-40-ml.jpg?v=1768586487",
        "handle": "la-roche-posay-effaclar-duo-m-40ml-anti-imperfections-peaux-grasses-1",
        "category": "visage",
        "tags": "acné, acnéique, anti marques, Anti-imperfections, crème hydratante, duo +, DUO(+) Soin correcteur, efaclar, Effaclar, grasse, hydratante, Hydratants, hydratation, imperfections, jour, matin, non comédogène, nuit, peau grasse, peaux grasses, peaux mixtes, Peaux à problèmes – Acné, sebum, soir, Visage, la roche-posay, visage"
      },
      {
        "title": "BIODERMA Sébium Kerato+ Gel Crème A nti Imperfections 30mL",
        "vendor": "Bioderma",
        "price": 177.23,
        "compareAt": 275,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/dfygfdt.png?v=1763749140",
        "handle": "bioderma-sebium-kerato-gel-creme-a-nti-imperfections-30m",
        "category": "visage",
        "tags": "ANTI IMPERFECTIONS, Bioderma, bioderma anti imperfections, bioderma sebium, CREME ANTI IMPERFECTIONS, creme visage, GEL CREME, GEL MOUSSANT ANTI IMPERFECTIONS, sébium kerato+, bioderma, visage"
      },
      {
        "title": "Bioderma Sensibio H2O Edition Speciale Victoria Beckham 500 ml",
        "vendor": "Bioderma",
        "price": 168,
        "compareAt": 190,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/bioderma-bioderma-sensibio-h2o-edition-speciale-victoria-beckham-500-ml-demaquillants-et-nettoyants.jpg?v=1745941755",
        "handle": "bioderma-sensibio-h2o-edition-speciale-victoria-beckham-500-ml",
        "category": "visage",
        "tags": "Bioderma, Bioderma – Sensibio H2O – 500 ml, Eau micellaire et Lotion, Nettoyant et Démaquillant, bioderma, visage"
      },
      {
        "title": "Caudalie Vinoperfect Crème Éclat Anti-Taches Jour 50Ml",
        "vendor": "Caudalie",
        "price": 411.6,
        "compareAt": 504,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/caudalieedze_1.jpg?v=1765974550",
        "handle": "caudalie-vinoperfect-creme-eclat-anti-taches",
        "category": "visage",
        "tags": "anti tache, anti taches, ANTI TACHES VISAGE, CAUDALIE, caudalie cremes, CAUDALIE VINOPERFECT, CREME ANTI TACHES, serum anti taches, SOIN ANTI TACHES, caudalie, visage"
      },
      {
        "title": "Svr Sebiaclear Gel Moussant 400 ml + Éco-Recharge 400 ml",
        "vendor": "SVR",
        "price": 196,
        "compareAt": 306,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Artboard1_afb69d4e-6e30-4114-9ca5-54ed320ab444.jpg?v=1741700968",
        "handle": "svr-sebiaclear-gel-moussant-400-ml-eco-recharge-400-ml",
        "category": "visage",
        "tags": "douche, ECO-RECHARGE, gel douche, Gel Moussant, Recharge, svr, visage"
      },
      {
        "title": "Eucerin Anti-Pigment Sérum Duo 30 ml - Pigment Control Fluid Offert",
        "vendor": "Eucerin",
        "price": 499,
        "compareAt": 659,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Post-Anti-pigment1-Global-para-prix-Maroc_1_1_1fcc2ab0-002c-4088-9540-b4a6d09d5a8d.jpg?v=1761152088",
        "handle": "eucerin-anti-pigment-serum-duo-30-ml-pigment-control-fluid-offret",
        "category": "visage",
        "tags": "eucerin, visage"
      },
      {
        "title": "Nuxe Rêve De Miel Soin Lèvres Au Miel 10 ml - Super Serum 5Ml + Huile Prodigieuse 10 ml Offerts",
        "vendor": "Nuxe",
        "price": 179,
        "compareAt": 199,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Artboard1copy7_722ae1db-5130-4456-85bc-3ad49b4634bb.jpg?v=1770753747",
        "handle": "nuxe-reve-de-miel-soin-levres-au-miel-10-ml-super-serum-5ml-huile-prodigieuse-10-ml-offerts",
        "category": "visage",
        "tags": "nuxe, visage"
      }
    ],
    "solaires": [
      {
        "title": "La roche posay anthelios teinte uvmune 400 gel creme oil control spf 50 - Eau thermale 50 ml Offerte",
        "vendor": "La Roche-Posay",
        "price": 165,
        "compareAt": 223,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/LRP-4_562c5c7b-81f4-4d1e-a1f3-4e48ffefc4e5.png?v=1769541052",
        "handle": "la-roche-posay-anthelios-teinte-uvmune-400-gel-creme-oil-control-spf-50-eau-thermale-50-ml-offerte",
        "category": "solaires",
        "tags": "Anthelios, creme solaipeau grasse, creme solaire, peau normale, peaux grasses, protection, re, solaire, soleil, SPF, SPF 50, UV, UVA, UVB, XL SPF50+ Gel-crème toucher sec, écran, ÉCRAN SOLAIRE, la roche-posay, solaires"
      },
      {
        "title": "ISDIN Fotoprotector Fusion Water Color MEDIUM SPF 50",
        "vendor": "Isdin",
        "price": 267.3,
        "compareAt": 269,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ISDINMEDIUM.png?v=1690297066",
        "handle": "isdin-fotoprotector-fusion-water-color-spf-50",
        "category": "solaires",
        "tags": "ISDIN, Pigmentation Crème Solaire Teintée SPF 50+, Promos Solaires, Protection solaire visage teintée, Solaire, ÉCRAN SOLAIRE, isdin, solaires"
      },
      {
        "title": "Eucerin Sun Protection Oil Control Gel-Crème Spf50+ 50 ml - Aquaphor 4Ml + Hydro Protect 5Ml Offerts",
        "vendor": "Eucerin",
        "price": 169,
        "compareAt": 199,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/EUCERINOILCONTROL.jpg?v=1770666084",
        "handle": "eucerin-sun-protection-oil-control-gel-creme-spf50-50-ml-aquaphor-4ml-hydro-protect-5ml-offerts",
        "category": "solaires",
        "tags": "eucerin, solaires"
      },
      {
        "title": "Eucerin – Sun Pigment Control Fluid Spf50+ 50 ml - Aquaphor 4Ml + Sérum Duo 7Ml Offerts",
        "vendor": "Eucerin",
        "price": 169,
        "compareAt": 209,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/EUCERINPIGMENTCONTROL.jpg?v=1770718245",
        "handle": "eucerin-sun-pigment-control-fluid-spf50-50-ml-1",
        "category": "solaires",
        "tags": "eucerin, solaires"
      },
      {
        "title": "Bioderma Photoderm Fluide Max Invisible Spf100 40Ml",
        "vendor": "Bioderma",
        "price": 160.95,
        "compareAt": 223,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ap_6f59d2f5-b901-4ba6-9043-334ca38eb819.png?v=1750504929",
        "handle": "bioderma-photoderm-max-fluide-spf100-40ml",
        "category": "solaires",
        "tags": "BIODERMA, bioderma photoderm, FLUID MAX, bioderma, solaires, protection solaire"
      },
      {
        "title": "Svr Ecran Sun Secure Blur Mousse Sans Parfums Spf50+ 50Ml",
        "vendor": "SVR",
        "price": 227.18,
        "compareAt": 359,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/1.7-Sun_Secure-Blur_SPF50_Sans_Parfum-1029M17-SVR-Protection_solaire_avec_effet_floutant.webp?v=1759665614",
        "handle": "svr-ecran-sun-secure-blur-mousse-sans-parfums-spf50-50ml",
        "category": "solaires",
        "tags": "BLUR, creme solaire, mixte, peau mixte, peaux normales, protection, protection solaire, Sans parfum, SECURE, Solaire, SPF50+, SVR, UVB, svr, solaires"
      },
      {
        "title": "Eucerin Hydro Protect Fluide Ultra Leger SPF 50+ - Gel Triple Action + Hydro Protect Offerts",
        "vendor": "Eucerin",
        "price": 205,
        "compareAt": 239,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/EUCERINHYDRO.jpg?v=1770718500",
        "handle": "eucerin-hydro-protect-fluide-ultra-leger-spf-50-gel-triple-action-hydro-protect-offert",
        "category": "solaires",
        "tags": "eucerin, solaires"
      },
      {
        "title": "Castalia Helioderm Fluide SPF 50+",
        "vendor": "Castalia",
        "price": 156.7,
        "compareAt": 240,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/castalia-helioderm-fluide-spf-50-40-ml.jpg?v=1714758971",
        "handle": "castalia-helioderm-creme-sans-parfum-spf-50",
        "category": "solaires",
        "tags": "castalia, solaires, crème solaire"
      }
    ],
    "cheveux": [
      {
        "title": "Vichy dercos shampooing 2en1 anti-pelliculaire ds et démêlant 200ml",
        "vendor": "Vichy",
        "price": 161.02,
        "compareAt": 249,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/dsss2.png?v=1737537569",
        "handle": "vichy-dercos-shampooing-2en1-anti-pelliculaire-ds-et-demelant-200ml",
        "category": "cheveux",
        "tags": "2 EN 1, anti peliculaire, Anti pelliculaire, Champoing, cheveu sensibles, cheveui sensible, cheveux sensible, cheveux sensibles, cuir chevelu sensible, Dercos, DÉMÊLANT, pelicule, pelliculaire, pellicule, pellicules, Sans sulfate, sensible, Shampoin, Shampoing, Shampoo, Shampooing, vichy, cheveux"
      },
      {
        "title": "DUCRAY Anaphase+ Shampoing Antichute Anti-Affinement – 400 ml",
        "vendor": "Ducray",
        "price": 216,
        "compareAt": 230,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/3_5e5b33a6-d34f-41e0-a544-fd079ed53ebb.png?v=1769611301",
        "handle": "ducray-anaphase-shampoing-antichute-anti-affinement-400-ml",
        "category": "cheveux",
        "tags": "anaphase, anti affinement, chute de cheveux, densite capillaire, shampoing antichute, SOIN CAPILLAIRE, ducray, cheveux, shampooing"
      },
      {
        "title": "Forcapil Lotion Spray Anti-chute 125ml",
        "vendor": "Forcapil",
        "price": 273.89,
        "compareAt": 415,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/arkopharma-forcapil-spray-anti-chute-125ml.webp?v=1769186725",
        "handle": "forcapil-lotion-spray-anti-chute-125ml",
        "category": "cheveux",
        "tags": "anti-chute, cuir chevelu, forcapil cheveux, forcapil, cheveux"
      },
      {
        "title": "Phyto Phytocyane Anti-Chute Femme - 87% Chute Freinée -12 Fioles X 5ml",
        "vendor": "PHYTO",
        "price": 690,
        "compareAt": 814,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/phytocyane-traitement-anti-chute-femme-chute-progressive-87-chute-freinee.webp?v=1765288611",
        "handle": "phyto-phytocyane-anti-chute-femme-87-chute-freinee-12-fioles-x-5ml",
        "category": "cheveux",
        "tags": "AMPOULES CHEVEUX, PHYTO, PHYTOCYANE, SOIN CAPILLAIRE, phyto, cheveux"
      },
      {
        "title": "Kérastase Genesis Homme Spray de Force Épaississant 150ml – Spray Fortifiant Homme",
        "vendor": "Kérastase",
        "price": 360,
        "compareAt": 425,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/77.png?v=1770210203",
        "handle": "kerastase-genesis-homme-spray-de-force-epaississant-150ml-spray-fortifiant-homme",
        "category": "cheveux",
        "tags": "ANTI CHUTE HOMME, cheveux fins homme, coiffage homme, densite cheveux, epaississant cheveux homme, hair spray homme, kerastase, kerastase genesis homme, soin capillaire professionnel, spray de force epaississant, spray fortifiant homme, kérastase, cheveux"
      },
      {
        "title": "Kérastase Genesis Homme Sérum Anti-Chute Fortifiant 90ml – Soin Cuir Chevelu Homme",
        "vendor": "Kérastase",
        "price": 415,
        "compareAt": 502,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/76.png?v=1770209611",
        "handle": "kerastase-genesis-homme-serum-anti-chute-fortifiant-90ml-soin-cuir-chevelu-homme",
        "category": "cheveux",
        "tags": "anti chute cheveux homme, cheveux affaiblis homme, fortification cheveux, kerastase, kerastase genesis homme, scalp care homme, serum anti chute homme, serum fortifiant homme, soin capillaire professionnel, soin cuir chevelu homme, kérastase, cheveux"
      },
      {
        "title": "Kérastase Genesis Homme Cire d’Épaisseur Texturisante 75ml – Cire Coiffante Épaississante",
        "vendor": "Kérastase",
        "price": 355,
        "compareAt": 422,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/75_d5c18542-8a4e-4af5-8f1b-0f9e8ccbe817.png?v=1770208160",
        "handle": "kerastase-genesis-homme-cire-d-epaisseur-texturisante-75ml-cire-coiffante-epaississante",
        "category": "cheveux",
        "tags": "cheveux fins homme, cire coiffante homme, cire texturisante, coiffage homme, densite cheveux, epaississant cheveux homme, hair styling wax, kerastase, kerastase genesis homme, soin capillaire professionnel, kérastase, homme"
      },
      {
        "title": "Kérastase Genesis Homme Bain de Masse Épaississant 250ml – Shampooing Épaississant Homme",
        "vendor": "Kérastase",
        "price": 255,
        "compareAt": 306,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/74.png?v=1770207530",
        "handle": "kerastase-genesis-homme-bain-de-masse-epaississant-250ml-shampooing-epaississant-homme",
        "category": "cheveux",
        "tags": "ANTI CHUTE HOMME, bain de masse epaississant, cheveux fins homme, densite cheveux, fortification cheveux, kerastase, kerastase genesis homme, shampooing epaississant, shampooing homme, shampooing professionnel, kérastase, cheveux"
      }
    ],
    "corps": [
      {
        "title": "Cerave baume hydratant nourrissant peau sèche à très sèche 177ml - Creme lavant 20ML+ Crème hydratante 3ML OFFERTS",
        "vendor": "Cerave",
        "price": 88,
        "compareAt": 104,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/CERAVEBAUMEF.jpg?v=1766661807",
        "handle": "cerave-baume-hydratant-nourrissant-peau-seche-a-tres-seche-177ml-creme-lavant-20ml-creme-hydratante-5ml-offerts",
        "category": "corps",
        "tags": "baume, Baume Hydratant, crème hydratante, céramides, hydratant, hydratante, hydratation, hydrate, lait, lotion, moisturising cream, peau sèche, peaux sèches, rème hydratante, Soin, très sèches, cerave, corps"
      },
      {
        "title": "Bioderma Atoderm Creme De Douche 200Ml",
        "vendor": "Bioderma",
        "price": 102,
        "compareAt": 169,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/hhv.png?v=1691752878",
        "handle": "bioderma-atoderm-creme-de-douche-200ml",
        "category": "corps",
        "tags": "Bioderma, bioderma, corps"
      },
      {
        "title": "La roche posay lipikar baume ap+ m 400ml",
        "vendor": "La Roche-Posay",
        "price": 277.14,
        "compareAt": 416,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Untitled-1_4ac41792-a48b-4253-b947-2f8f240a1092.jpg?v=1744553253",
        "handle": "la-roche-posay-lipikar-baume-ap-m400ml",
        "category": "corps",
        "tags": "Baume Hydratant, la roche-posay, corps"
      },
      {
        "title": "Nuxe Reve De Miel Crème Mains Et Ongles 30 ml+ Stick Lèvres 4G - Super Serum 5Ml + Huile Prodigieuse 10 ml Offerts",
        "vendor": "Nuxe",
        "price": 143,
        "compareAt": 189,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Artboard1copy7_bd53f840-a059-451f-837b-eb75cff6ee3a.jpg?v=1770752218",
        "handle": "nuxe-reve-de-miel-creme-mains-et-ongles-30-ml-stick-levres-4g-super-serum-5ml-huile-prodigieuse-10-ml-offerts",
        "category": "corps",
        "tags": "nuxe, visage"
      },
      {
        "title": "Sterilance Lancets Standart 28G",
        "vendor": "STERILANCE",
        "price": 40,
        "compareAt": 47,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/dd6edfdf-1859-4c7d-8780-4f545b806f49.png?v=1770456928",
        "handle": "sterilance-lancets-standart-28g",
        "category": "corps",
        "tags": "Corps, Diabète, lancets, lancettes steriles, sterilance, visage"
      },
      {
        "title": "LCP Baume Chauffant Mains Engelures 75ml",
        "vendor": "LCP",
        "price": 84.39,
        "compareAt": 131,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ChatGPTImageFeb6_2026_05_48_45PM.png?v=1770396508",
        "handle": "lcp-baume-chauffant-mains-engelures-75ml",
        "category": "corps",
        "tags": "mains, mains sEches, lcp, visage"
      },
      {
        "title": "Lcp Baume Chauffant Pieds Secs 100ml",
        "vendor": "LCP",
        "price": 97,
        "compareAt": 150,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Lcp-Baume-Chauffant-Pieds-Secs-100ml-1.webp?v=1770390593",
        "handle": "lcp-baume-chauffant-pieds-secs-100ml",
        "category": "corps",
        "tags": "baume chauffant, pied secs, pieds, lcp, visage"
      },
      {
        "title": "BIODERMA Cicabio – Baume Lavant Nettoyant Apaisant Protecteur – 200 ml",
        "vendor": "Bioderma",
        "price": 129,
        "compareAt": 151,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/3701129810019.webp?v=1770282671",
        "handle": "bioderma-cicabio-baume-lavant-nettoyant-apaisant-protecteur-200-ml",
        "category": "corps",
        "tags": "baume lavant, Bioderma, cicabio, dermatologie, hygiene douce, peau irritee, soin reparateur, bioderma, visage, baume nettoyant"
      }
    ],
    "bebe": [
      {
        "title": "Mustela Gel Lavant Doux Avocat 750ml",
        "vendor": "MUSTELA",
        "price": 203.7,
        "compareAt": 315,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Bebemaman-Mustela-Gel-Lavant-Doux-a-lAvocat-750ml.webp?v=1766594951",
        "handle": "mustela-gel-lavant-doux-avocat-750ml",
        "category": "bebe",
        "tags": "MUSTELA, mustela gel lavant, mustela, visage"
      },
      {
        "title": "Mustela pack bio gel lavant 400ml + bio crème de change 75ml + baume universel 75ml - trousse ungle offerte",
        "vendor": "Mustela",
        "price": 349,
        "compareAt": 410,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Plandetravail33.jpg?v=1732552353",
        "handle": "mustela-bio-gel-lavant-400ml-bio-creme-de-change-75ml-baume-universel-75ml-trousse-jungle-offerte",
        "category": "bebe",
        "tags": "hydratation bebe, MUSTELA, mustela baume, mustela bebe, mustela creme de change, mustela gel lavant, mustela, bébé & maman, bébé et maman"
      },
      {
        "title": "Bioderma AbcDerm Change Intensif – 75 ml",
        "vendor": "Bioderma",
        "price": 70,
        "compareAt": 109,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/products/ABC-Derm-change-intensif-75g-3401396924944-bioderma_621fd4a5-687c-4962-b887-e14f732bd33e.jpg?v=1765376143",
        "handle": "abcderm-change-intensif-75-ml",
        "category": "bebe",
        "tags": "Soins du siège, bioderma, bébé & maman, bébé et maman"
      },
      {
        "title": "WaterWipes – Pack Lingettes Bébé -9x60 Pièces",
        "vendor": "WaterWipes",
        "price": 415,
        "compareAt": 530,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/CopiedeCopiede_3.png?v=1770290448",
        "handle": "waterwipes-pack-lingettes-bebe-9-x-60-pieces",
        "category": "bebe",
        "tags": "bébé maman, Hygiène bébé, Lingettes bébé, nouveau né, peau sensible, soin doux, WATERWIPES, waterwipes, bébé & maman, lingettes"
      },
      {
        "title": "Valise Maternité Économie 20% OFF",
        "vendor": "ParaVogue",
        "price": 1852,
        "compareAt": 2222,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/DFGFTGF.png?v=1713459699",
        "handle": "valise-maternite",
        "category": "bebe",
        "tags": "avent biberons, AVENT SUCETTES, AVENT TETINES, BAMBO COUCHES, BEBE, BEBE ET MAMAN, carre soin, Goupillon, klorane bebe, klorane creme hydratant, klorane eau, klorane gel douche, klorane lait, klorane parfum, LANSINOH, lansinoh creme, LANSINOH SACHETS, LINGETTES, Lingettes bébé, liquid vessel biberon, medela tire lait, philips avent sucettes, TIRE LAIT, TIRE LAIT ELECTRIQUE, tire lait solo, Valise Maternité, WATERWIPES, bébé & maman, bébé et maman"
      },
      {
        "title": "dodot Sensitive 2 ans - 4-8kg 58pc",
        "vendor": "DODOT",
        "price": 189,
        "compareAt": 223,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/106437_1-dodot-sensitive-panales-58-uds_1.jpg?v=1770216975",
        "handle": "dodot-sensitive-2-ans-4-8kg-58pc",
        "category": "bebe",
        "tags": "2 ans, couches, Couches bébé, DODOT, dodot couches, dodot, visage"
      },
      {
        "title": "Vitabio Cool Fruits POMME BANANE 12x90G",
        "vendor": "Vitabio",
        "price": 142,
        "compareAt": 168,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/vitabio-pomme-banane-12x90g.webp?v=1770132658",
        "handle": "vitabio-cool-fruits-pomme-banane-12x90g",
        "category": "bebe",
        "tags": "cool fruits, fruits purée, nutrition, purée  pomme, purée banane, Vitabio, vitabio, visage, bébés et tout-petits"
      },
      {
        "title": "Neutraderm Carrés De Soin Visage & Corps 100 Piéces",
        "vendor": "Neutraderm",
        "price": 36,
        "compareAt": 54,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/neutradem.jpg?v=1770029846",
        "handle": "neutraderm-carres-de-soin-visage-corps-100-pieces",
        "category": "bebe",
        "tags": "Change de bébé, Toilette et Soin de bébé, neutraderm, bébé & maman, bébé et maman"
      }
    ],
    "complements": [
      {
        "title": "Forcapil Pack Fortifiant 180 Gélules - Fortifiant 60 Gélules Offert",
        "vendor": "Forcapil",
        "price": 372,
        "compareAt": 509,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Forcapil-Promo-11024_1_fb14043e-5053-4895-add6-626fe74c89d9.webp?v=1765880988",
        "handle": "forcapil-pack-fortifiant-180-gelules-fortifiant-60-gelules-offert",
        "category": "complements",
        "tags": "forcapil, compléments alimentaires, complement alimentaire"
      },
      {
        "title": "GPH Duffision Spiruline Bio 100 Comprimes",
        "vendor": "Gph Diffusion",
        "price": 135,
        "compareAt": 203,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Gph-Spiruline-Bio-100cps.webp?v=1770628741",
        "handle": "gph-duffision-spiruline-bio-100-comprimes",
        "category": "complements",
        "tags": "SPIRULINE, gph diffusion, compléments alimentaires, complement alimentaire"
      },
      {
        "title": "Tricovel Neo SincroBiogenina 30 comprimés",
        "vendor": "Tricovel",
        "price": 257,
        "compareAt": 309,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/A3447115-p1.jpg?v=1770402819",
        "handle": "tricovel-neo-sincrobiogenina-30-comprimes",
        "category": "complements",
        "tags": "COMPLEMENT, complements, Compléments alimentaires, food supplements, MAGNESIUM, Ornithine, Tricovel, vitamin C, VITAMINES, tricovel, compléments alimentaires, complement alimentaire"
      },
      {
        "title": "Hada Labo Tokyo Crème Anti-Âge Réductrice des Rides Jour 50 ml",
        "vendor": "Hada Labo",
        "price": 189,
        "compareAt": 223,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/CtiFwtHdKXEBSyZV7PPBtl.webp?v=1770715761",
        "handle": "hada-labo-tokyo-creme-anti-age-reductrice-des-rides-jour-50-ml",
        "category": "complements",
        "tags": "acide hyaluronique, Anti-âge, creme anti rides, creme collagène, Hada Labo, Rétinol, hada labo, visage, crème de jour"
      },
      {
        "title": "GPH Marron d’inde 250mg 200gelules",
        "vendor": "Gph Diffusion",
        "price": 220,
        "compareAt": 260,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ChatGPTImageFeb9_2026_10_28_07AM.png?v=1770629269",
        "handle": "gph-marron-d-inde-250mg-200gelules",
        "category": "complements",
        "tags": "GPH, Marron d’inde, gph diffusion, visage, complement alimentaire"
      },
      {
        "title": "Bionuva Ashwagandha 300 MG -60 gélules",
        "vendor": "Bionuva",
        "price": 129,
        "compareAt": 152,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ASHWAGANDHA.webp?v=1770397001",
        "handle": "bionuva-ashwagandha-300-mg-60-gelules",
        "category": "complements",
        "tags": "Ashwaganda, complément alimentaire, réduction du stress, Vitalité, bionuva, compléments alimentaires, complement alimentaire"
      },
      {
        "title": "VITALL+ Collagène Articulaire Poudre 120 Gr",
        "vendor": "VIT'ALL",
        "price": 299,
        "compareAt": 353,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/vitall-vitall-collagene-articulaire-poudre-120-g-articulations-et-crampes.jpg?v=1770389483",
        "handle": "vitall-collagene-articulaire-poudre-120-gr",
        "category": "complements",
        "tags": "Collagene Articulaire, Collagène, Collagène marin, vit'all, visage, complement alimentaire"
      },
      {
        "title": "Cantabria-Iraltone Aga Labs 60 Capsules",
        "vendor": "cantabria",
        "price": 322.42,
        "compareAt": 494,
        "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/8470002462533.webp?v=1770388570",
        "handle": "cantabria-iraltone-aga-labs-60-capsules",
        "category": "complements",
        "tags": "COMPLEMENT ALIMENTAIRE, Iraltone, Iraltone AGA, cantabria, visage, complement alimentaire"
      }
    ]
  },
  "all": [
    {
      "title": "Cerave gel moussant nettoyant peau normale à grasse 473ml - Gel moussant 20ML + gel creme hydratant 15ml + Trousse OFFERTS",
      "vendor": "Cerave",
      "price": 147,
      "compareAt": 150,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/GELMOUSSANT_bebbf92a-dffd-4d9c-b7b9-064f8ed9662e.png?v=1769107657",
      "handle": "cerave-gel-moussant-nettoyant-peau-normale-a-grasse-473ml-gel-moussant-20ml-trousse-offerts",
      "category": "visage",
      "tags": "cerave gel, Gel Moussant, Gel moussant purifiant, gel nettoyents, peau normale, PEAU NORMALE A GRASSE, cerave, visage"
    },
    {
      "title": "Cerave baume hydratant – 340 g - Crème Lavante 20ml + Crème Hydratante 15ml + Trousse OFFERTS",
      "vendor": "Cerave",
      "price": 134,
      "compareAt": 162,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/GHFTG.png?v=1769108266",
      "handle": "cerave-baume-hydratant-340-g-creme-lavante-20ml-creme-hydratante-15ml-trousse-offerts",
      "category": "visage",
      "tags": "baume, Baume Hydratant, crème hydratante, céramides, hydratant, hydratante, hydratation, hydrate, lait, lotion, moisturising cream, peau sèche, peaux sèches, Soin, très sèches, cerave, corps"
    },
    {
      "title": "La Roche-Posay Effaclar Duo+M 40ml – Anti-Imperfections Peaux Grasses",
      "vendor": "La Roche-Posay",
      "price": 179,
      "compareAt": 185,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/la-roche-posay-effaclar-duo-m-40-ml.jpg?v=1768586487",
      "handle": "la-roche-posay-effaclar-duo-m-40ml-anti-imperfections-peaux-grasses-1",
      "category": "visage",
      "tags": "acné, acnéique, anti marques, Anti-imperfections, crème hydratante, duo +, DUO(+) Soin correcteur, efaclar, Effaclar, grasse, hydratante, Hydratants, hydratation, imperfections, jour, matin, non comédogène, nuit, peau grasse, peaux grasses, peaux mixtes, Peaux à problèmes – Acné, sebum, soir, Visage, la roche-posay, visage"
    },
    {
      "title": "BIODERMA Sébium Kerato+ Gel Crème A nti Imperfections 30mL",
      "vendor": "Bioderma",
      "price": 162,
      "compareAt": 199,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/dfygfdt.png?v=1763749140",
      "handle": "bioderma-sebium-kerato-gel-creme-a-nti-imperfections-30m",
      "category": "visage",
      "tags": "ANTI IMPERFECTIONS, Bioderma, bioderma anti imperfections, bioderma sebium, CREME ANTI IMPERFECTIONS, creme visage, GEL CREME, GEL MOUSSANT ANTI IMPERFECTIONS, sébium kerato+, bioderma, visage"
    },
    {
      "title": "Bioderma Sensibio H2O Edition Speciale Victoria Beckham 500 ml",
      "vendor": "Bioderma",
      "price": 168,
      "compareAt": 190,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/bioderma-bioderma-sensibio-h2o-edition-speciale-victoria-beckham-500-ml-demaquillants-et-nettoyants.jpg?v=1745941755",
      "handle": "bioderma-sensibio-h2o-edition-speciale-victoria-beckham-500-ml",
      "category": "visage",
      "tags": "Bioderma, Bioderma – Sensibio H2O – 500 ml, Eau micellaire et Lotion, Nettoyant et Démaquillant, bioderma, visage"
    },
    {
      "title": "Caudalie Vinoperfect Crème Éclat Anti-Taches Jour 50Ml",
      "vendor": "Caudalie",
      "price": 420,
      "compareAt": 504,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/caudalieedze_1.jpg?v=1765974550",
      "handle": "caudalie-vinoperfect-creme-eclat-anti-taches",
      "category": "visage",
      "tags": "anti tache, anti taches, ANTI TACHES VISAGE, CAUDALIE, caudalie cremes, CAUDALIE VINOPERFECT, CREME ANTI TACHES, serum anti taches, SOIN ANTI TACHES, caudalie, visage"
    },
    {
      "title": "Svr Sebiaclear Gel Moussant 400 ml + Éco-Recharge 400 ml",
      "vendor": "SVR",
      "price": 269,
      "compareAt": 329,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Artboard1_afb69d4e-6e30-4114-9ca5-54ed320ab444.jpg?v=1741700968",
      "handle": "svr-sebiaclear-gel-moussant-400-ml-eco-recharge-400-ml",
      "category": "visage",
      "tags": "douche, ECO-RECHARGE, gel douche, Gel Moussant, Recharge, svr, visage"
    },
    {
      "title": "Eucerin Anti-Pigment Sérum Duo 30 ml - Pigment Control Fluid Offert",
      "vendor": "Eucerin",
      "price": 499,
      "compareAt": 659,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Post-Anti-pigment1-Global-para-prix-Maroc_1_1_1fcc2ab0-002c-4088-9540-b4a6d09d5a8d.jpg?v=1761152088",
      "handle": "eucerin-anti-pigment-serum-duo-30-ml-pigment-control-fluid-offret",
      "category": "visage",
      "tags": "eucerin, visage"
    },
    {
      "title": "Nuxe Rêve De Miel Soin Lèvres Au Miel 10 ml - Super Serum 5Ml + Huile Prodigieuse 10 ml Offerts",
      "vendor": "Nuxe",
      "price": 179,
      "compareAt": 199,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Artboard1copy7_722ae1db-5130-4456-85bc-3ad49b4634bb.jpg?v=1770753747",
      "handle": "nuxe-reve-de-miel-soin-levres-au-miel-10-ml-super-serum-5ml-huile-prodigieuse-10-ml-offerts",
      "category": "visage",
      "tags": "nuxe, visage"
    },
    {
      "title": "La roche posay anthelios teinte uvmune 400 gel creme oil control spf 50 - Eau thermale 50 ml Offerte",
      "vendor": "La Roche-Posay",
      "price": 165,
      "compareAt": 223,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/LRP-4_562c5c7b-81f4-4d1e-a1f3-4e48ffefc4e5.png?v=1769541052",
      "handle": "la-roche-posay-anthelios-teinte-uvmune-400-gel-creme-oil-control-spf-50-eau-thermale-50-ml-offerte",
      "category": "solaires",
      "tags": "Anthelios, creme solaipeau grasse, creme solaire, peau normale, peaux grasses, protection, re, solaire, soleil, SPF, SPF 50, UV, UVA, UVB, XL SPF50+ Gel-crème toucher sec, écran, ÉCRAN SOLAIRE, la roche-posay, solaires"
    },
    {
      "title": "ISDIN Fotoprotector Fusion Water Color MEDIUM SPF 50",
      "vendor": "Isdin",
      "price": 234,
      "compareAt": 269,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ISDINMEDIUM.png?v=1690297066",
      "handle": "isdin-fotoprotector-fusion-water-color-spf-50",
      "category": "solaires",
      "tags": "ISDIN, Pigmentation Crème Solaire Teintée SPF 50+, Promos Solaires, Protection solaire visage teintée, Solaire, ÉCRAN SOLAIRE, isdin, solaires"
    },
    {
      "title": "Eucerin Sun Protection Oil Control Gel-Crème Spf50+ 50 ml - Aquaphor 4Ml + Hydro Protect 5Ml Offerts",
      "vendor": "Eucerin",
      "price": 169,
      "compareAt": 199,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/EUCERINOILCONTROL.jpg?v=1770666084",
      "handle": "eucerin-sun-protection-oil-control-gel-creme-spf50-50-ml-aquaphor-4ml-hydro-protect-5ml-offerts",
      "category": "solaires",
      "tags": "eucerin, solaires"
    },
    {
      "title": "Eucerin – Sun Pigment Control Fluid Spf50+ 50 ml - Aquaphor 4Ml + Sérum Duo 7Ml Offerts",
      "vendor": "Eucerin",
      "price": 169,
      "compareAt": 209,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/EUCERINPIGMENTCONTROL.jpg?v=1770718245",
      "handle": "eucerin-sun-pigment-control-fluid-spf50-50-ml-1",
      "category": "solaires",
      "tags": "eucerin, solaires"
    },
    {
      "title": "Bioderma Photoderm Fluide Max Invisible Spf100 40Ml",
      "vendor": "Bioderma",
      "price": 159,
      "compareAt": 223,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ap_6f59d2f5-b901-4ba6-9043-334ca38eb819.png?v=1750504929",
      "handle": "bioderma-photoderm-max-fluide-spf100-40ml",
      "category": "solaires",
      "tags": "BIODERMA, bioderma photoderm, FLUID MAX, bioderma, solaires, protection solaire"
    },
    {
      "title": "Svr Ecran Sun Secure Blur Mousse Sans Parfums Spf50+ 50Ml",
      "vendor": "SVR",
      "price": 209,
      "compareAt": 250,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/1.7-Sun_Secure-Blur_SPF50_Sans_Parfum-1029M17-SVR-Protection_solaire_avec_effet_floutant.webp?v=1759665614",
      "handle": "svr-ecran-sun-secure-blur-mousse-sans-parfums-spf50-50ml",
      "category": "solaires",
      "tags": "BLUR, creme solaire, mixte, peau mixte, peaux normales, protection, protection solaire, Sans parfum, SECURE, Solaire, SPF50+, SVR, UVB, svr, solaires"
    },
    {
      "title": "Eucerin Hydro Protect Fluide Ultra Leger SPF 50+ - Gel Triple Action + Hydro Protect Offerts",
      "vendor": "Eucerin",
      "price": 205,
      "compareAt": 239,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/EUCERINHYDRO.jpg?v=1770718500",
      "handle": "eucerin-hydro-protect-fluide-ultra-leger-spf-50-gel-triple-action-hydro-protect-offert",
      "category": "solaires",
      "tags": "eucerin, solaires"
    },
    {
      "title": "Castalia Helioderm Fluide SPF 50+",
      "vendor": "Castalia",
      "price": 152,
      "compareAt": 175,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/castalia-helioderm-fluide-spf-50-40-ml.jpg?v=1714758971",
      "handle": "castalia-helioderm-creme-sans-parfum-spf-50",
      "category": "solaires",
      "tags": "castalia, solaires, crème solaire"
    },
    {
      "title": "Vichy dercos shampooing 2en1 anti-pelliculaire ds et démêlant 200ml",
      "vendor": "Vichy",
      "price": 157,
      "compareAt": 160,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/dsss2.png?v=1737537569",
      "handle": "vichy-dercos-shampooing-2en1-anti-pelliculaire-ds-et-demelant-200ml",
      "category": "cheveux",
      "tags": "2 EN 1, anti peliculaire, Anti pelliculaire, Champoing, cheveu sensibles, cheveui sensible, cheveux sensible, cheveux sensibles, cuir chevelu sensible, Dercos, DÉMÊLANT, pelicule, pelliculaire, pellicule, pellicules, Sans sulfate, sensible, Shampoin, Shampoing, Shampoo, Shampooing, vichy, cheveux"
    },
    {
      "title": "DUCRAY Anaphase+ Shampoing Antichute Anti-Affinement – 400 ml",
      "vendor": "Ducray",
      "price": 195,
      "compareAt": 244,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/3_5e5b33a6-d34f-41e0-a544-fd079ed53ebb.png?v=1769611301",
      "handle": "ducray-anaphase-shampoing-antichute-anti-affinement-400-ml",
      "category": "cheveux",
      "tags": "anaphase, anti affinement, chute de cheveux, densite capillaire, shampoing antichute, SOIN CAPILLAIRE, ducray, cheveux, shampooing"
    },
    {
      "title": "Forcapil Lotion Spray Anti-chute 125ml",
      "vendor": "Forcapil",
      "price": 275,
      "compareAt": 344,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/arkopharma-forcapil-spray-anti-chute-125ml.webp?v=1769186725",
      "handle": "forcapil-lotion-spray-anti-chute-125ml",
      "category": "cheveux",
      "tags": "anti-chute, cuir chevelu, forcapil cheveux, forcapil, cheveux"
    },
    {
      "title": "Phyto Phytocyane Anti-Chute Femme - 87% Chute Freinée -12 Fioles X 5ml",
      "vendor": "PHYTO",
      "price": 690,
      "compareAt": 863,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/phytocyane-traitement-anti-chute-femme-chute-progressive-87-chute-freinee.webp?v=1765288611",
      "handle": "phyto-phytocyane-anti-chute-femme-87-chute-freinee-12-fioles-x-5ml",
      "category": "cheveux",
      "tags": "AMPOULES CHEVEUX, PHYTO, PHYTOCYANE, SOIN CAPILLAIRE, phyto, cheveux"
    },
    {
      "title": "Kérastase Genesis Homme Spray de Force Épaississant 150ml – Spray Fortifiant Homme",
      "vendor": "Kérastase",
      "price": 360,
      "compareAt": 450,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/77.png?v=1770210203",
      "handle": "kerastase-genesis-homme-spray-de-force-epaississant-150ml-spray-fortifiant-homme",
      "category": "cheveux",
      "tags": "ANTI CHUTE HOMME, cheveux fins homme, coiffage homme, densite cheveux, epaississant cheveux homme, hair spray homme, kerastase, kerastase genesis homme, soin capillaire professionnel, spray de force epaississant, spray fortifiant homme, kérastase, cheveux"
    },
    {
      "title": "Kérastase Genesis Homme Sérum Anti-Chute Fortifiant 90ml – Soin Cuir Chevelu Homme",
      "vendor": "Kérastase",
      "price": 425,
      "compareAt": 531,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/76.png?v=1770209611",
      "handle": "kerastase-genesis-homme-serum-anti-chute-fortifiant-90ml-soin-cuir-chevelu-homme",
      "category": "cheveux",
      "tags": "anti chute cheveux homme, cheveux affaiblis homme, fortification cheveux, kerastase, kerastase genesis homme, scalp care homme, serum anti chute homme, serum fortifiant homme, soin capillaire professionnel, soin cuir chevelu homme, kérastase, cheveux"
    },
    {
      "title": "Kérastase Genesis Homme Cire d’Épaisseur Texturisante 75ml – Cire Coiffante Épaississante",
      "vendor": "Kérastase",
      "price": 358,
      "compareAt": 448,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/75_d5c18542-8a4e-4af5-8f1b-0f9e8ccbe817.png?v=1770208160",
      "handle": "kerastase-genesis-homme-cire-d-epaisseur-texturisante-75ml-cire-coiffante-epaississante",
      "category": "cheveux",
      "tags": "cheveux fins homme, cire coiffante homme, cire texturisante, coiffage homme, densite cheveux, epaississant cheveux homme, hair styling wax, kerastase, kerastase genesis homme, soin capillaire professionnel, kérastase, homme"
    },
    {
      "title": "Kérastase Genesis Homme Bain de Masse Épaississant 250ml – Shampooing Épaississant Homme",
      "vendor": "Kérastase",
      "price": 259,
      "compareAt": 324,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/74.png?v=1770207530",
      "handle": "kerastase-genesis-homme-bain-de-masse-epaississant-250ml-shampooing-epaississant-homme",
      "category": "cheveux",
      "tags": "ANTI CHUTE HOMME, bain de masse epaississant, cheveux fins homme, densite cheveux, fortification cheveux, kerastase, kerastase genesis homme, shampooing epaississant, shampooing homme, shampooing professionnel, kérastase, cheveux"
    },
    {
      "title": "Cerave baume hydratant nourrissant peau sèche à très sèche 177ml - Creme lavant 20ML+ Crème hydratante 3ML OFFERTS",
      "vendor": "Cerave",
      "price": 88,
      "compareAt": 104,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/CERAVEBAUMEF.jpg?v=1766661807",
      "handle": "cerave-baume-hydratant-nourrissant-peau-seche-a-tres-seche-177ml-creme-lavant-20ml-creme-hydratante-5ml-offerts",
      "category": "corps",
      "tags": "baume, Baume Hydratant, crème hydratante, céramides, hydratant, hydratante, hydratation, hydrate, lait, lotion, moisturising cream, peau sèche, peaux sèches, rème hydratante, Soin, très sèches, cerave, corps"
    },
    {
      "title": "Bioderma Atoderm Creme De Douche 200Ml",
      "vendor": "Bioderma",
      "price": 102,
      "compareAt": 169,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/hhv.png?v=1691752878",
      "handle": "bioderma-atoderm-creme-de-douche-200ml",
      "category": "corps",
      "tags": "Bioderma, bioderma, corps"
    },
    {
      "title": "La roche posay lipikar baume ap+ m 400ml",
      "vendor": "La Roche-Posay",
      "price": 262,
      "compareAt": 270,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Untitled-1_4ac41792-a48b-4253-b947-2f8f240a1092.jpg?v=1744553253",
      "handle": "la-roche-posay-lipikar-baume-ap-m400ml",
      "category": "corps",
      "tags": "Baume Hydratant, la roche-posay, corps"
    },
    {
      "title": "Nuxe Reve De Miel Crème Mains Et Ongles 30 ml+ Stick Lèvres 4G - Super Serum 5Ml + Huile Prodigieuse 10 ml Offerts",
      "vendor": "Nuxe",
      "price": 143,
      "compareAt": 189,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Artboard1copy7_bd53f840-a059-451f-837b-eb75cff6ee3a.jpg?v=1770752218",
      "handle": "nuxe-reve-de-miel-creme-mains-et-ongles-30-ml-stick-levres-4g-super-serum-5ml-huile-prodigieuse-10-ml-offerts",
      "category": "corps",
      "tags": "nuxe, visage"
    },
    {
      "title": "Sterilance Lancets Standart 28G",
      "vendor": "STERILANCE",
      "price": 40,
      "compareAt": 50,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/dd6edfdf-1859-4c7d-8780-4f545b806f49.png?v=1770456928",
      "handle": "sterilance-lancets-standart-28g",
      "category": "corps",
      "tags": "Corps, Diabète, lancets, lancettes steriles, sterilance, visage"
    },
    {
      "title": "LCP Baume Chauffant Mains Engelures 75ml",
      "vendor": "LCP",
      "price": 83,
      "compareAt": 104,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ChatGPTImageFeb6_2026_05_48_45PM.png?v=1770396508",
      "handle": "lcp-baume-chauffant-mains-engelures-75ml",
      "category": "corps",
      "tags": "mains, mains sEches, lcp, visage"
    },
    {
      "title": "Lcp Baume Chauffant Pieds Secs 100ml",
      "vendor": "LCP",
      "price": 95,
      "compareAt": 119,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Lcp-Baume-Chauffant-Pieds-Secs-100ml-1.webp?v=1770390593",
      "handle": "lcp-baume-chauffant-pieds-secs-100ml",
      "category": "corps",
      "tags": "baume chauffant, pied secs, pieds, lcp, visage"
    },
    {
      "title": "BIODERMA Cicabio – Baume Lavant Nettoyant Apaisant Protecteur – 200 ml",
      "vendor": "Bioderma",
      "price": 128,
      "compareAt": 160,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/3701129810019.webp?v=1770282671",
      "handle": "bioderma-cicabio-baume-lavant-nettoyant-apaisant-protecteur-200-ml",
      "category": "corps",
      "tags": "baume lavant, Bioderma, cicabio, dermatologie, hygiene douce, peau irritee, soin reparateur, bioderma, visage, baume nettoyant"
    },
    {
      "title": "Mustela Gel Lavant Doux Avocat 750ml",
      "vendor": "MUSTELA",
      "price": 189,
      "compareAt": 299,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Bebemaman-Mustela-Gel-Lavant-Doux-a-lAvocat-750ml.webp?v=1766594951",
      "handle": "mustela-gel-lavant-doux-avocat-750ml",
      "category": "bebe",
      "tags": "MUSTELA, mustela gel lavant, mustela, visage"
    },
    {
      "title": "Mustela pack bio gel lavant 400ml + bio crème de change 75ml + baume universel 75ml - trousse ungle offerte",
      "vendor": "Mustela",
      "price": 349,
      "compareAt": 410,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Plandetravail33.jpg?v=1732552353",
      "handle": "mustela-bio-gel-lavant-400ml-bio-creme-de-change-75ml-baume-universel-75ml-trousse-jungle-offerte",
      "category": "bebe",
      "tags": "hydratation bebe, MUSTELA, mustela baume, mustela bebe, mustela creme de change, mustela gel lavant, mustela, bébé & maman, bébé et maman"
    },
    {
      "title": "Bioderma AbcDerm Change Intensif – 75 ml",
      "vendor": "Bioderma",
      "price": 70,
      "compareAt": 109,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/products/ABC-Derm-change-intensif-75g-3401396924944-bioderma_621fd4a5-687c-4962-b887-e14f732bd33e.jpg?v=1765376143",
      "handle": "abcderm-change-intensif-75-ml",
      "category": "bebe",
      "tags": "Soins du siège, bioderma, bébé & maman, bébé et maman"
    },
    {
      "title": "WaterWipes – Pack Lingettes Bébé -9x60 Pièces",
      "vendor": "WaterWipes",
      "price": 415,
      "compareAt": 530,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/CopiedeCopiede_3.png?v=1770290448",
      "handle": "waterwipes-pack-lingettes-bebe-9-x-60-pieces",
      "category": "bebe",
      "tags": "bébé maman, Hygiène bébé, Lingettes bébé, nouveau né, peau sensible, soin doux, WATERWIPES, waterwipes, bébé & maman, lingettes"
    },
    {
      "title": "Valise Maternité Économie 20% OFF",
      "vendor": "ParaVogue",
      "price": 1852,
      "compareAt": 2222,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/DFGFTGF.png?v=1713459699",
      "handle": "valise-maternite",
      "category": "bebe",
      "tags": "avent biberons, AVENT SUCETTES, AVENT TETINES, BAMBO COUCHES, BEBE, BEBE ET MAMAN, carre soin, Goupillon, klorane bebe, klorane creme hydratant, klorane eau, klorane gel douche, klorane lait, klorane parfum, LANSINOH, lansinoh creme, LANSINOH SACHETS, LINGETTES, Lingettes bébé, liquid vessel biberon, medela tire lait, philips avent sucettes, TIRE LAIT, TIRE LAIT ELECTRIQUE, tire lait solo, Valise Maternité, WATERWIPES, bébé & maman, bébé et maman"
    },
    {
      "title": "dodot Sensitive 2 ans - 4-8kg 58pc",
      "vendor": "DODOT",
      "price": 189,
      "compareAt": 236,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/106437_1-dodot-sensitive-panales-58-uds_1.jpg?v=1770216975",
      "handle": "dodot-sensitive-2-ans-4-8kg-58pc",
      "category": "bebe",
      "tags": "2 ans, couches, Couches bébé, DODOT, dodot couches, dodot, visage"
    },
    {
      "title": "Vitabio Cool Fruits POMME BANANE 12x90G",
      "vendor": "Vitabio",
      "price": 142,
      "compareAt": 178,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/vitabio-pomme-banane-12x90g.webp?v=1770132658",
      "handle": "vitabio-cool-fruits-pomme-banane-12x90g",
      "category": "bebe",
      "tags": "cool fruits, fruits purée, nutrition, purée  pomme, purée banane, Vitabio, vitabio, visage, bébés et tout-petits"
    },
    {
      "title": "Neutraderm Carrés De Soin Visage & Corps 100 Piéces",
      "vendor": "Neutraderm",
      "price": 34,
      "compareAt": 51,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/neutradem.jpg?v=1770029846",
      "handle": "neutraderm-carres-de-soin-visage-corps-100-pieces",
      "category": "bebe",
      "tags": "Change de bébé, Toilette et Soin de bébé, neutraderm, bébé & maman, bébé et maman"
    },
    {
      "title": "Forcapil Pack Fortifiant 180 Gélules - Fortifiant 60 Gélules Offert",
      "vendor": "Forcapil",
      "price": 339,
      "compareAt": 509,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Forcapil-Promo-11024_1_fb14043e-5053-4895-add6-626fe74c89d9.webp?v=1765880988",
      "handle": "forcapil-pack-fortifiant-180-gelules-fortifiant-60-gelules-offert",
      "category": "complements",
      "tags": "forcapil, compléments alimentaires, complement alimentaire"
    },
    {
      "title": "GPH Duffision Spiruline Bio 100 Comprimes",
      "vendor": "Gph Diffusion",
      "price": 135,
      "compareAt": 169,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/Gph-Spiruline-Bio-100cps.webp?v=1770628741",
      "handle": "gph-duffision-spiruline-bio-100-comprimes",
      "category": "complements",
      "tags": "SPIRULINE, gph diffusion, compléments alimentaires, complement alimentaire"
    },
    {
      "title": "Tricovel Neo SincroBiogenina 30 comprimés",
      "vendor": "Tricovel",
      "price": 257,
      "compareAt": 309,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/A3447115-p1.jpg?v=1770402819",
      "handle": "tricovel-neo-sincrobiogenina-30-comprimes",
      "category": "complements",
      "tags": "COMPLEMENT, complements, Compléments alimentaires, food supplements, MAGNESIUM, Ornithine, Tricovel, vitamin C, VITAMINES, tricovel, compléments alimentaires, complement alimentaire"
    },
    {
      "title": "Hada Labo Tokyo Crème Anti-Âge Réductrice des Rides Jour 50 ml",
      "vendor": "Hada Labo",
      "price": 189,
      "compareAt": 236,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/CtiFwtHdKXEBSyZV7PPBtl.webp?v=1770715761",
      "handle": "hada-labo-tokyo-creme-anti-age-reductrice-des-rides-jour-50-ml",
      "category": "complements",
      "tags": "acide hyaluronique, Anti-âge, creme anti rides, creme collagène, Hada Labo, Rétinol, hada labo, visage, crème de jour"
    },
    {
      "title": "GPH Marron d’inde 250mg 200gelules",
      "vendor": "Gph Diffusion",
      "price": 220,
      "compareAt": 275,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ChatGPTImageFeb9_2026_10_28_07AM.png?v=1770629269",
      "handle": "gph-marron-d-inde-250mg-200gelules",
      "category": "complements",
      "tags": "GPH, Marron d’inde, gph diffusion, visage, complement alimentaire"
    },
    {
      "title": "Bionuva Ashwagandha 300 MG -60 gélules",
      "vendor": "Bionuva",
      "price": 129,
      "compareAt": 161,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/ASHWAGANDHA.webp?v=1770397001",
      "handle": "bionuva-ashwagandha-300-mg-60-gelules",
      "category": "complements",
      "tags": "Ashwaganda, complément alimentaire, réduction du stress, Vitalité, bionuva, compléments alimentaires, complement alimentaire"
    },
    {
      "title": "VITALL+ Collagène Articulaire Poudre 120 Gr",
      "vendor": "VIT'ALL",
      "price": 299,
      "compareAt": 374,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/vitall-vitall-collagene-articulaire-poudre-120-g-articulations-et-crampes.jpg?v=1770389483",
      "handle": "vitall-collagene-articulaire-poudre-120-gr",
      "category": "complements",
      "tags": "Collagene Articulaire, Collagène, Collagène marin, vit'all, visage, complement alimentaire"
    },
    {
      "title": "Cantabria-Iraltone Aga Labs 60 Capsules",
      "vendor": "cantabria",
      "price": 312,
      "compareAt": 390,
      "image": "https://cdn.shopify.com/s/files/1/0572/7938/1679/files/8470002462533.webp?v=1770388570",
      "handle": "cantabria-iraltone-aga-labs-60-capsules",
      "category": "complements",
      "tags": "COMPLEMENT ALIMENTAIRE, Iraltone, Iraltone AGA, cantabria, visage, complement alimentaire"
    }
  ]
};
window.PARAVOGUE_SUBCATS = {
  "visage": [
    "Tous les soins visage",
    "Nettoyants & Démaquillants",
    "Sérums & Soins Ciblés",
    "Anti-Imperfections & Acné",
    "Crèmes Hydratantes & Barrière",
    "Anti-Âge & Rides",
    "Soins des Lèvres"
  ],
  "solaires": [
    "Toutes les protections solaires",
    "Fluides Invisibles SPF 50+",
    "Crèmes Solaires Teintées",
    "Solaires Peaux Grasses & Acné",
    "Solaires Bébé, Enfant & Famille",
    "Brumes & Sticks Solaires"
  ],
  "cheveux": [
    "Tous les soins cheveux",
    "Anti-Chute & Densifiants",
    "Shampoings Anti-Pelliculaires",
    "Masques & Soins Réparateurs",
    "Shampoings Doux Quotidiens",
    "Compléments Capillaires"
  ],
  "corps": [
    "Tous les soins corps",
    "Baumes & Laits Hydratants",
    "Huiles Lavantes & Gels Douche",
    "Déodorants & Anti-Transpirants",
    "Soins Mains & Pieds"
  ],
  "bebe": [
    "Tout pour bébé & maman",
    "Toilette & Bain Bébé",
    "Crèmes pour le Change & Érythème",
    "Eaux Nettoyantes & Lingettes",
    "Maternité & Allaitement"
  ],
  "complements": [
    "Tous les compléments",
    "Cheveux & Ongles",
    "Peau & Beauté",
    "Énergie & Immunité",
    "Minceur & Détox"
  ]
};
